import React from 'react';
import '../styles/landing-modern.css';
import { useLanguage } from '../contexts/LanguageContext';
import SEOHead from '../components/SEOHead';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import Benefits from '../components/landing/Benefits';
import Solutions from '../components/landing/Solutions';
import DemoSection from '../components/landing/DemoSection';
import TrustSection from '../components/landing/TrustSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';

const LANDING_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'FretManager',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description:
    'Plateforme de gestion de fret international avec suivi en temps réel.',
};

const LandingPageModern = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEOHead
        title={t('seoLandingTitle')}
        description={t('seoLandingDesc')}
        canonical="/"
        ogType="website"
        jsonLd={LANDING_JSON_LD}
      />
      <Navbar scrollTo={scrollTo} />
      <Hero />
      <Benefits />
      <Solutions />
      <DemoSection />
      <TrustSection />
      <CTASection />
      <Footer scrollTo={scrollTo} />
    </div>
  );
};

export default LandingPageModern;
